import { QueryClient } from "@tanstack/react-query";

// A booking was made, changed or cancelled: the bookings list and every free-space count are now out of date.
export const refreshBookings = (queryClient: QueryClient) => Promise.all([
    queryClient.invalidateQueries({ queryKey: ['bookings'] }),
    queryClient.invalidateQueries({ queryKey: ['spaces'] }),
]);
